import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Loader from '../shared/Loader';
import { FontSizes, Heading, Copy } from '@hexure/ui';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
`;

const SectionTitle = styled.h3`
  font-size: ${FontSizes.MEDIUM};
  font-weight: 450;
  margin-bottom: 8px;
`;

const InfoRow = styled.div`
  display: flex;
  gap: 40px;
`;

const DetailsSpan = styled.span`
  font-size: 14px;
  font-weight: 450;
  font-family: Roboto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid #e5e5e5;
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 12px;
  font-weight: 400;
  border: 1px solid #ddd;
  background-color: #f9f9f9;
  font-size: 14px;
`;

const TableCell = styled.td`
  padding: 12px;
  border: 1px solid #ddd;
  font-size: ${FontSizes.SMALL};
`;

const Details = styled.div`
  font-size: ${FontSizes.SMALL};
  line-height: 1.6;
`;

const formatRate = value => (value ? `${value}%` : 'N/A');

const RiderInfo = ({ data, loading }) => {
  const ageBands = Object.entries(data?.age_band_single_rates || {});

  const parsedAgeBands = ageBands.map(([range, rate]) => {
    const values = Array.isArray(rate) ? rate : rate.split(',');
    return {
      range,
      single: values[0],
      joint: values[1]?.trim() ?? 'N/A'
    };
  });

  return loading ? (
    <Loader />
  ) : (
    <Container>
      <Heading type='tertiary'>{data?.name}</Heading>
      <Copy style={{ marginTop: '20px' }}>{data?.description}</Copy>

      <SectionTitle>Age Bands</SectionTitle>
      <InfoRow>
        <Table>
          <thead>
            <tr>
              <TableHeader>Age</TableHeader>
              <TableHeader>Single</TableHeader>
              <TableHeader>Joint</TableHeader>
            </tr>
          </thead>
          <tbody>
            {parsedAgeBands.map(({ range, single, joint }) => (
              <tr key={range}>
                <TableCell>{range}</TableCell>
                <TableCell>{formatRate(single)}</TableCell>
                <TableCell>{formatRate(joint)}</TableCell>
              </tr>
            ))}
          </tbody>
        </Table>

        <Details>
          <Copy>
            <DetailsSpan>Waiting Period:</DetailsSpan> {`${data?.waiting_period} Contract Year` || 'N/A'}
          </Copy>
          <Copy>
            <DetailsSpan>Cancellation Term:</DetailsSpan> {data?.cancellation_terms || 'N/A'}
          </Copy>
          <Copy>
            <DetailsSpan>Charge Basis:</DetailsSpan> {data?.charge_basis || 'N/A'}
          </Copy>
          <Copy>
            <DetailsSpan>Charge:</DetailsSpan> {formatRate(data?.charge ? `${Math.trunc(data.charge * 100) / 100}` : 'N/A')}
          </Copy>
        </Details>
      </InfoRow>
    </Container>
  );
};

RiderInfo.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool
};

export default RiderInfo;
